"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = (0, _makeStyles.default)(function (theme) {
  return {
    productDetail: {
      "& .mco-shop-product-detail-back-button": {
        marginBottom: theme.spacing(4)
      },
      "& .mco-shop-product-detail-tags": {
        marginBottom: theme.spacing(2)
      },
      "& .mco-shop-product-detail-item-number": {
        marginTop: theme.spacing(2)
      },
      "& .mco-shop-product-detail-price": {
        marginTop: theme.spacing(1)
      },
      "& .mco-shop-product-detail-availability": {
        marginTop: theme.spacing(2)
      },
      "& .mco-shop-product-detail-rating": {
        marginTop: theme.spacing(4)
      },
      "& .mco-shop-product-detail-description": {
        marginTop: theme.spacing(2)
      },
      "& .mco-shop-product-detail-combination-selection": {
        marginTop: theme.spacing(4)
      },
      "& .mco-shop-product-detail-voucher-selection": {
        marginTop: theme.spacing(4)
      },
      "& .mco-shop-product-detail-buttons": {
        display: "flex",
        marginTop: theme.spacing(4)
      },
      "& .mco-shop-product-detail-cart-button": {
        flex: 1
      },
      "& .mco-shop-product-detail-quantity": {
        marginRight: theme.spacing(2)
      },
      "& .mco-shop-product-detail-bookmark": {
        marginLeft: theme.spacing(0.5)
      },
      "& .mco-shop-product-detail-gallery": {
        marginBottom: theme.spacing(3)
      },
      "& .mco-shop-product-detail-descriptions": {
        marginBottom: theme.spacing(3)
      }
    },
    wrapper: {
      "&::after": {
        clear: "both",
        content: "''",
        display: "block"
      }
    },
    rightColumn: _defineProperty({
      marginBottom: theme.spacing(3)
    }, theme.breakpoints.up("md"), {
      float: "right",
      marginBottom: 0,
      position: "sticky",
      top: 0,
      width: 427
    }),
    content: _defineProperty({}, theme.breakpoints.up("md"), {
      marginRight: 451
    }),
    recommendations: {
      marginTop: theme.spacing(10)
    }
  };
});
var _default = styles;
exports.default = _default;